export interface SourceOfFunds {
    id?: string;
    detailsOfSourceOfFunds?: string;
    supportingDocumentReceived?: string;
    linkToSupportingDocuments?: string;
    politicallyExposed?: string;
    comments?: string;
    individualName?: string;
    institutionName?: string;
    complianceName?: string;
    name?: string;
    dateCreated?: Date;
    dateModified?: Date;
    createdBy?: string;
    modifiedBy?: string;
}

export class SourceOfFundsPanelController {
    public isOpen: boolean = false;
    public isEdit: boolean = false;
    public sourceOfFunds: SourceOfFunds = {};
    public errorMessage: string = '';
    public isLoading: boolean = false;
    public onSave: (sourceOfFunds: SourceOfFunds) => void;
    public onClose: () => void;
    public onDelete: (sourceOfFunds: SourceOfFunds) => void;

    /** @ngInject */
    constructor() {}

    public $onInit(): void {
        this.resetForm();
    }

    public open(sourceOfFunds?: SourceOfFunds): void {
        this.isOpen = true;
        this.isEdit = !!sourceOfFunds;
        this.errorMessage = ''; // Clear any previous errors
        
        // Prevent body scroll
        document.body.classList.add('slide-out-panel-open');
        
        if (sourceOfFunds && typeof sourceOfFunds === 'object') {
            this.sourceOfFunds = { ...sourceOfFunds };
        } else {
            this.resetForm();
        }
    }

    public close(): void {
        this.isOpen = false;
        this.errorMessage = ''; // Clear errors when closing
        
        // Restore body scroll
        document.body.classList.remove('slide-out-panel-open');
        
        if (this.onClose) {
            this.onClose();
        }
    }

    public save(): void {        
        // Clear previous error messages
        this.errorMessage = '';
        
        // Validate required fields
        if (!this.sourceOfFunds || !this.sourceOfFunds.detailsOfSourceOfFunds) {
            this.errorMessage = 'Details of Source of Funds is required. Please provide details before saving.';
            console.error('Details of Source of Funds is required');
            return; // Don't save or close the panel
        }

        // Ensure sourceOfFunds is properly initialized
        if (!this.sourceOfFunds) {
            this.sourceOfFunds = {};
        }

        // Set loading state
        this.isLoading = true;

        // Add timestamps
        if (!this.sourceOfFunds.dateCreated) {
            this.sourceOfFunds.dateCreated = new Date();
        }
        this.sourceOfFunds.dateModified = new Date();

        if (this.onSave) {
            (this.onSave as any)({ sourceOfFunds: this.sourceOfFunds });
        }
        
        // Reset loading state and close
        this.isLoading = false;
        this.close();
    }



    public delete(): void {
        if (this.sourceOfFunds && this.sourceOfFunds.id) {
            if (this.onDelete) {
                (this.onDelete as any)({ sourceOfFunds: this.sourceOfFunds });
            }
        }
        this.close();
    }

    private resetForm(): void {
        this.sourceOfFunds = {
            id: undefined,
            detailsOfSourceOfFunds: '',
            supportingDocumentReceived: '',
            linkToSupportingDocuments: '',
            politicallyExposed: '',
            comments: '',
            individualName: '',
            institutionName: '',
            complianceName: '',
            name: '',
            dateCreated: null,
            dateModified: null,
            createdBy: '',
            modifiedBy: ''
        };

    }
}

export const SourceOfFundsPanelComponent: angular.IComponentOptions = {
    template: require('./source-of-funds-panel.html'),
    controller: SourceOfFundsPanelController,
    controllerAs: '$ctrl',
    bindings: {
        onSave: '&',
        onClose: '&',
        onDelete: '&'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/compliance/modals/tabs/source-of-funds/source-of-funds-panel.ts